<template>
  <div>
    <generic-container
      :title="$t('human task compose')"
      icon="object group outline"
      :show_plus="false"
      :searchable="false"
      style="margin-top: 15px"
      :header_buttons="header_buttons"
    >
      <div class="ui items">
        <div class="item">
          <div class="ui tiny circular image">
            <img src="/images/icons/human_task.png" />
          </div>
          <div class="content">
            <a class="header">{{ human_task.name }}</a>
            <div class="description">{{ human_task.description }}</div>
            <div class="meta"></div>
            <div class="extra"></div>
          </div>
        </div>
      </div>
      <div class="ui four item pointing menu">
        <a class="item active" data-tab="html">
          <i class="html5 icon"></i>
          {{ $t("html code") }}
        </a>
        <a class="item" data-tab="mixin">
          <i class="js icon"></i>
          {{ $t("mixin") }}
        </a>
        <a class="item" data-tab="modifiers" v-if="false">
          <i class="code icon"></i>
          {{ $t("modifiers") }}
        </a>
        <a class="item" data-tab="arguments">
          <i class="list icon"></i>
          {{ $t("arguments") }}
        </a>
        <a class="item" data-tab="outcomes">
          <i class="check icon"></i>
          {{ $t("outcomes") }}
        </a>
      </div>
      <div class="ui bottom attached tab active" data-tab="html">
        <code-editor
          v-model="human_task.html"
          type="html"
          icon="html5"
          theme="monokai"
          ref="html_code_editor"
          :title="$t('html code')"
          :show_format="true"
          :header_menus="html_header_menus"
        ></code-editor>
      </div>
      <div class="ui bottom attached tab" data-tab="mixin">
        <mixin-management :human_task="human_task" :templates="templates" />
      </div>
      <div class="ui bottom attached tab" data-tab="modifiers">
        <modifier-management :human_task="human_task" />
      </div>
      <div class="ui bottom attached tab" data-tab="arguments">
        <argument-management
          :human_task="human_task"
          :business_objects="business_objects"
        />
      </div>
      <div class="ui bottom attached tab" data-tab="outcomes">
        <outcome-management :human_task="human_task" />
      </div>
    </generic-container>
    <generic-container
      :title="$t('preview')"
      icon="eye"
      :show_plus="false"
      :searchable="false"
      style="margin-top: 15px"
      :header_buttons="header_buttons_preview"
    >
      <div>
        <div
          style="z-index: 1000"
          class="ui icon labeled right floated basic button"
          v-for="(outcome, idx) in human_task.outcomes"
          :key="idx"
        >
          <i :class="outcome.icon + ' icon'"></i>
          {{ outcome.name }}
        </div>
      </div>
      <div class="ui form" ref="preview_form" v-html="human_task.html"></div>
    </generic-container>
    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        :modifier="selected_modifier"
        v-on:destroy="destroy_popup"
        v-on:succedded="succedded_modifier"
      ></component>
    </template>
    <template v-for="(mdl, index) in ht_modals">
      <component
        :is="mdl"
        :key="index"
        :human_task="human_task"
        v-on:destroy="destroy_ht"
        v-on:succedded="succedded_ht"
      ></component>
    </template>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import MixinManagement from "./MixinManagement";
import ModifierManagement from "./ModifiersManagement";
import ArgumentManagement from "./ArgumentManagement";
import OutcomeManagement from "./OutcomeManagement";
import HumanTaskModal from "./HumanTaskModal";
import { local_api, error_toast, success_toast, stringify } from "@/utils";
import filters from "@/filters";
import HtmlTemplates from "./HtmlTemplates";
import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "Composer",
  filters: filters,
  components: {
    GenericContainer,
    MixinManagement,
    ModifierManagement,
    ArgumentManagement,
    OutcomeManagement,
    HtmlTemplates,
    CodeEditor,
  },
  data() {
    return {
      popup_modals: [],
      ht_modals: [],
      human_task: {},
      business_objects: [],
      header_buttons: [
        { icon: "left arrow", click: this.back },
        { icon: "blue save", click: this.save },
        { icon: "orange edit", click: this.edit },
      ],
      header_buttons_preview: [{ icon: "magic wand", click: this.animate }],
      templates: [],
    };
  },
  computed: {
    html_header_menus() {
      let vm = this;
      return [
        {
          tooltip: this.$t("format code"),
          icon: "wrench",
          buttons: this.templates
            .filter((t) => t.type == "html")
            .map((n) => {
              return {
                icon: n.icon,
                text: n.name,
                click: function () {
                  console.log("sdfsdf");
                  vm.$refs.html_code_editor.insert_content(n.template);
                },
              };
            }),
        },
      ];
    },
  },
  methods: {
    save() {
      let vm = this;
      let projectUuid = this.$route.query.j;
      let humanTaskUuid = this.$route.query.h;

      local_api(vm, "post", "/ngine_composer/human_task/do-save", {
        p: projectUuid,
        h: humanTaskUuid,
        s: JSON.stringify(vm.human_task),
      })
        .then(() => {
          success_toast(vm.$t("updated successfully"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    edit() {
      this.ht_modals.push(HumanTaskModal);
    },
    destroy_ht() {
      this.ht_modals = [];
    },
    succedded_ht(ht) {
      this.human_task.name = ht.name;
      this.human_task.description = ht.description;
    },
    animate() {
      let vm = this;
      let projectUuid = vm.$route.query.j;
      let humanTaskUuid = vm.$route.query.h;
      let route = vm.$router.resolve({
        name: "NgineComposerHumanTaskTester",
        query: { j: projectUuid, h: humanTaskUuid },
      });
      // let route = this.$router.resolve({ path: "/contact" });
      window.open(route.href);
      // window
      //   .jQuery(this.$refs.preview_form)
      //   .find(".ui.dropdown")
      //   .dropdown();
      // window
      //   .jQuery(this.$refs.preview_form)
      //   .find(".ui.calendar")
      //   .calendar();
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    let vm = this;
    let projectUuid = this.$route.query.j;
    let humanTaskUuid = this.$route.query.h;

    if (projectUuid && humanTaskUuid) {
      local_api(vm, "post", "/ngine_composer/human_task/do-get", {
        p: projectUuid,
        h: humanTaskUuid,
      })
        .then((resp) => {
          if (resp) {
            let ht = resp.human_task;
            let business_objects = resp.business_objects;
            if (ht) {
              ht.html = ht.html || "";
              ht.modifiers = ht.modifiers || [];
              ht.args = ht.args || [];
              ht.outcomes = ht.outcomes || [];
              vm.human_task = ht;
              vm.business_objects = business_objects;

              /*var editor = ace.edit("html_editor");
              editor.setValue(ht.html);
              editor.getSession().setMode("ace/mode/html");
              editor.setTheme("ace/theme/monokai");
              editor.getSession().on("change", function() {
                let val = editor.getValue();
                vm.human_task.html = val;
              });*/
            } else error_toast(vm.$t("no data received"));
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    } else {
      error_toast(this.$t("no project"));
    }

    window.jQuery(".ui.pointing.menu .item").tab();
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/ngine_composer/human_task/do-get-templates")
      .then((templates) => {
        vm.templates = templates;
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {},
};
</script>

<style>
.pusher {
  margin-top: unset;
}

div#html_editor {
  width: 100%;
  min-height: 500px;
}
</style>
